<div class="container" [class.active]="selected">
    <span data-cy="graphs-empty-grid-slot" class="plus-icon" [class.active]="selected">+</span>
</div>